<script lang="ts" setup>
import type { NotivueItem } from 'notivue'
provideHeadlessUseId(() => useId())
</script>

<template>
  <NuxtPwaManifest />
  <Notivue v-slot="item">
    <AcceptGeo v-if="item.props.isAcceptGeo" :item="item as NotivueItem<IAcceptGeoProps>" />
    <InstallRequest v-else-if="item.props.isInstallRequest" :item="item as NotivueItem<IInstallRequestProps>" />
    <DeleteDocuments v-else-if="item.props.isDeleteRequest" :item="item as NotivueItem<IAcceptDeleteDocumentProps>" />
    <Notification v-else :item="item">
      <NotificationProgress :item="item" />
    </Notification>
  </Notivue>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
